function createAccordionEvent(
  elementId,
  pageId,
  eventId,
  autoStopEventId,
  mediaQueries,
  actionListId
) {
  return {
    id: eventId,
    name: "",
    animationType: "custom",
    eventTypeId: "MOUSE_CLICK",
    action: {
      id: "",
      actionTypeId: "GENERAL_START_ACTION",
      config: {
        delay: 0,
        easing: "",
        duration: 0,
        actionListId,
        affectedElements: {},
        playInReverse: false,
        autoStopEventId,
      },
    },
    mediaQueries,
    target: {
      id: `${pageId}|${elementId}`,
      appliesTo: "ELEMENT",
      styleBlockIds: [],
    },
    targets: [
      {
        id: `${pageId}|${elementId}`,
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
    ],
    config: {
      loop: false,
      playInReverse: false,
      scrollOffsetValue: null,
      scrollOffsetUnit: null,
      delay: null,
      direction: null,
      effectIn: null,
    },
    createdOn: Date.now(),
  };
}

function generateEvents(pageId, accordionIds) {
  const events = {};

  accordionIds.forEach((id, index) => {
    const openEventMainId = `e-${index * 2 + 2}`; // Main media query OPEN
    const openEventSmallId = `e-${index * 2 + 1}`; // Small media queries OPEN

    events[openEventSmallId] = createAccordionEvent(
      id.columnId,
      pageId,
      openEventSmallId,
      "e",
      ["medium", "small", "tiny"],
      "a-2"
    );
    events[openEventMainId] = createAccordionEvent(
      id.accordionId,
      pageId,
      openEventMainId,
      "e",
      ["main"],
      "a"
    );
  });

  return events;
}

function getEvents(pageId, accordionIds) {
  const events = generateEvents(pageId, accordionIds);
  return {
    events: {
      ...events,
    },
    actionLists: {
      "a-2": {
        id: "a-2",
        title: "Layout 351 accordion [Open] [Tablet]",
        actionItemGroups: [
          {
            actionItems: [
              {
                id: "a-2-n",
                actionTypeId: "STYLE_SIZE",
                config: {
                  delay: 0,
                  easing: "",
                  duration: 500,
                  target: {
                    selector: ".layout351_column-content",
                    selectorGuids: ["f1015ba2-acb1-9667-17d9-a40fe0aab6d0"],
                  },
                  heightValue: 0,
                  widthUnit: "PX",
                  heightUnit: "px",
                  locked: false,
                },
              },
              {
                id: "a-2-n-2",
                actionTypeId: "STYLE_SIZE",
                config: {
                  delay: 0,
                  easing: "",
                  duration: 500,
                  target: {
                    selector: ".layout351_column-content.active",
                    selectorGuids: [
                      "f1015ba2-acb1-9667-17d9-a40fe0aab6d0",
                      "f1015ba2-acb1-9667-17d9-a40fe0aab6da",
                    ],
                  },
                  widthUnit: "PX",
                  heightUnit: "AUTO",
                  locked: false,
                },
              },
            ],
          },
          {
            actionItems: [
              {
                id: "a-2-n-3",
                actionTypeId: "STYLE_SIZE",
                config: {
                  delay: 0,
                  easing: "ease",
                  duration: 500,
                  target: {
                    selector: ".layout351_column-content",
                    selectorGuids: ["f1015ba2-acb1-9667-17d9-a40fe0aab6d0"],
                  },
                  heightValue: 0,
                  widthUnit: "PX",
                  heightUnit: "px",
                  locked: false,
                },
              },
              {
                id: "a-2-n-4",
                actionTypeId: "STYLE_SIZE",
                config: {
                  delay: 0,
                  easing: "ease",
                  duration: 500,
                  target: {
                    useEventTarget: "SIBLINGS",
                    selector: ".layout351_column-content",
                    selectorGuids: ["f1015ba2-acb1-9667-17d9-a40fe0aab6d0"],
                  },
                  widthUnit: "PX",
                  heightUnit: "AUTO",
                  locked: false,
                },
              },
            ],
          },
        ],
        useFirstGroupAsInitialState: true,
        createdOn: 1651363294716,
      },
      a: {
        id: "a",
        title: "Layout 351 accordion [Open] [Desktop]",
        actionItemGroups: [
          {
            actionItems: [
              {
                id: "a-n",
                actionTypeId: "STYLE_SIZE",
                config: {
                  delay: 0,
                  easing: "ease",
                  duration: 500,
                  target: {
                    selector: ".layout351_accordion",
                    selectorGuids: ["f1015ba2-acb1-9667-17d9-a40fe0aab6d4"],
                  },
                  widthValue: 5,
                  widthUnit: "rem",
                  heightUnit: "PX",
                  locked: false,
                },
              },
              {
                id: "a-n-2",
                actionTypeId: "STYLE_SIZE",
                config: {
                  delay: 0,
                  easing: "ease",
                  duration: 500,
                  target: {
                    useEventTarget: true,
                    id: `${pageId}|b120366c-2f9d-201c-4e5b-7d711f58e028`,
                  },
                  widthValue: 100,
                  widthUnit: "%",
                  heightUnit: "PX",
                  locked: false,
                },
              },
            ],
          },
        ],
      },
    },
  };
}

// eslint-disable-next-line import/no-default-export
export default getEvents;
